<template>
  <div class="col-sm-12 nopads">
    <h2 class="editor-header"> {{ priceList.id > 0 ? $t('pricelist.edit') : $t('pricelist.add') }}</h2>
    <div class="col-sm-12 editor-form">
        <div class="row">
        <div class="col-sm-6 nopads">
          <span class="span-title">
            {{ $t('pricelist.name') }}
          </span>
            <input
                id="name"
                v-model="priceList.name"
                type="text"
                class="form-control form-control-sm"
                :placeholder="$t('pricelist.name_tip')"
            />
        </div>
        <div class="col-sm-6 nopads">
          <span class="span-title">
            {{ $t('pricelist.distance_unit') }}
          </span>
            <select
                id="d-unit"
                v-model="priceList.distance_unit"
                class="form-select form-select-sm"
            >
                <option
                    v-for="option in distanceUnitOptions"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.text }}
                </option>
            </select>
        </div>
      </div>
        <div class="row">
        <div class="col-sm-6 nopads">
          <span class="span-title">
            {{ $t('pricelist.weight_unit') }}
          </span>
            <select
                id="w-unit"
                v-model="priceList.weight_unit"
                class="form-select form-select-sm"
            >
                <option
                    v-for="option in weightUnitOptions"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.text }}
                </option>
            </select>
        </div>
        <div class="col-sm-6 nopads">
          <span class="span-title">
            {{ $t('pricelist.multiplier') }}
          </span>
            <input
                id="multiplier"
                v-model.number="priceList.multiplier"
                type="number"
                step="0.001"
                class="form-control form-control-sm"
            />
        </div>
      </div>
        <div class="row">
            <div
              v-if="priceList.id && priceList.id > 0"
              class="col-sm-6 nopads"
            >
              <span class="span-title">
                {{ $t('pricelist.active') }}
              </span>
                <input
                    id="active"
                    v-model="priceList.active"
                    type="checkbox"
                    class="form-check-input"
                    name="checkbox"
                />
            </div>
        </div>
        <span class="span-title">
          {{ $t('pricelist.prices') }}
        </span>

        <!-- Price ranges -->
        <div class="row p-2 mb-3" style="height: 30em; overflow: auto">
            <price-range-selector
                v-for="(item, index) in priceList.prices"
                :key="index"
                :price="item"
                :multiplier="priceList.multiplier"
                :weight-unit="priceList.weight_unit"
                :distance-unit="priceList.distance_unit"
            />
        </div>

        <!-- Buttons -->
        <div class="col-sm-12 d-flex justify-content-end">
          <button
            class="btn btn-sm btn-secondary form-button"
            @click.stop="$emit('close')"
          >
            {{ $t('common.cancel') }}
          </button>
          <button
            class="btn btn-success btn-sm form-button"
            :disabled="loading"
            @click.stop="submitPriceList"
          >
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import PriceRangeSelector from "./PriceRangeSelector";
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";

export default {
    name: 'PriceListEditor',
    components: {Navbar, PriceRangeSelector},
    mixins: [restApi],
    props: {
        priceList: {
            type: Object,
            default: null
        },
        hideTitle: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            priceListUpdate: this.priceList,
            distanceUnitOptions: [
                { value: 'km', text: 'km' },
                { value: 'm', text: 'm' },
            ],
            weightUnitOptions: [
                { value: 'kg', text: 'kg' },
                { value: 't', text: 't' },
            ]
        }
    },

    methods: {
        setDefaultValues: function (priceList) {
            if (priceList.name === '') {
                this.showAlert(this.$t('pricelist.invalid_name'))
                return undefined
            }
            if (!priceList.distance_unit) {
                this.showAlert(this.$t('pricelist.invalid_distance_unit'))
                return undefined
            }
            if (!priceList.weight_unit) {
                this.showAlert(this.$t('pricelist.invalid_weight_unit'))
                return undefined
            }
            if (priceList.prices.length < 1) {
                this.showAlert(this.$t('pricelist.invalid_prices'))
                return undefined
            }
            if (!priceList.multiplier || priceList.multiplier <= 0) {
                this.showAlert(this.$t('pricelist.invalid_multiplier'))
                return undefined
            }
            if (!priceList.created_at) {
                let now = new Date()
                priceList.created_at = now.toISOString()
            }
            return priceList
        },

        submitPriceList: function () {
            var json = this.setDefaultValues(this.priceList)
            if (json !== undefined) {
                this.loading = true
                if (!this.priceList.id || this.priceList.id < 1) {
                    this.restAdd(this.priceListWeightDistanceUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.priceListWeightDistanceUrl, json, this.success, this.fail)
                }
            }
        },

        success: function (response) {
            this.$emit('closeAndUpdate', response)
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
